import React, { FC } from 'react'

import clsx from 'clsx'

import { Txt } from 'src/components/atoms'
import { Checkbox } from 'src/components/atoms/inputs/Checkbox'

type Props = {
  text: string
  checked: boolean
  disabled?: boolean
  checkboxPosition?: 'left' | 'right'
  size?: 's' | 'm'
  onClick: () => void
  className?: string
}

export const CheckboxWithTxt: FC<Props> = ({
  text,
  checked,
  disabled = false,
  checkboxPosition = 'left',
  size = 'm',
  onClick,
  className,
}) => {
  return (
    <div className={className} role="presentation" onClick={onClick}>
      <div className={clsx('tw-flex tw-items-center', !disabled && 'tw-cursor-pointer')}>
        {checkboxPosition === 'left' && (
          <Checkbox nonce={undefined} checked={checked} disabled={disabled} className="tw-mr-s-2" />
        )}
        <Txt
          sizeType={size}
          className={clsx('tw-break-keep', disabled ? 'tw-opacity-30' : 'tw-opacity-100')}
        >
          {text}
        </Txt>
        {checkboxPosition === 'right' && (
          <Checkbox nonce={undefined} checked={checked} disabled={disabled} className="tw-ml-s-2" />
        )}
      </div>
    </div>
  )
}
